import { User } from './user';
import { TestItemType } from './testItem';

export enum TestRunStatus {
    DRAFT = 'draft',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    BLOCKED = 'blocked',
    CANCELLED = 'cancelled'
}

export enum TestRunItemStatus {
    NOT_STARTED = 'not_started',
    IN_PROGRESS = 'in_progress',
    PASSED = 'passed',
    FAILED = 'failed',
    BLOCKED = 'blocked',
    SKIPPED = 'skipped'
}

export enum TestRunStepStatus {
    NOT_STARTED = 'not_started',
    PASSED = 'passed',
    FAILED = 'failed',
    BLOCKED = 'blocked',
    SKIPPED = 'skipped'
}

export interface TestItem {
    id: number;
    title: string;
    description: string;
    type: string;
    priority: string;
    severity: string;
    status: string;
    steps?: TestStep[];
    check_items?: CheckItem[];
}

export interface TestStep {
    step_number: number;
    description: string;
    expected_result: string;
}

export interface CheckItem {
    step_number: number;
    description: string;
    expected_result: string;
}

export interface TestRunStep {
    id: number;
    test_run_item_id: number;
    step_number: number;
    description?: string;
    expected_result?: string;
    actual_result?: string;
    status: TestRunStepStatus;
    checklist?: CheckItem[];
    created_at: string;
    updated_at?: string;
}

export interface TestRunItem {
    id: number;
    test_run_id: number;
    test_item_id: number;
    status: TestRunItemStatus;
    assigned_to_id?: number;
    assigned_to?: User;
    notes?: string;
    test_run_steps?: TestRunStep[];
    folder_id?: number;
    folder?: {
        id: number;
        name: string;
        test_data?: {
            id: number;
            name: string;
            description?: string;
            data: any;
            attachment_ids?: number[];
            tags?: string[];
            project_id: number;
            folder_id: number;
            created_by?: number;
            created_at: string;
            updated_at?: string;
        }[];
        shared_steps?: {
            id: number;
            name: string;
            description?: string;
            steps: any[];
            project_id: number;
            folder_id: number;
            created_by?: number;
            created_at: string;
            updated_at?: string;
        }[];
    };
    test_item?: {
        id: number;
        name: string;
        title: string;
        description?: string;
        type: TestItemType;
        steps?: TestStep[];
        check_items?: CheckItem[];
        test_data?: {
            id: number;
            name: string;
            description?: string;
            data: any;
            attachment_ids?: number[];
            tags?: string[];
            project_id: number;
            folder_id: number;
            created_by?: number;
            created_at: string;
            updated_at?: string;
        }[];
        shared_steps?: {
            id: number;
            name: string;
            description?: string;
            steps: any[];
            project_id: number;
            folder_id: number;
            created_by?: number;
            created_at: string;
            updated_at?: string;
        }[];
    };
    shared_steps?: {
        id: number;
        name: string;
    }[];
}

export interface TestRun {
    id: number;
    name: string;
    description?: string;
    project_id: number;
    project_name: string;
    environment: string;
    status: TestRunStatus;
    created_at: string;
    updated_at: string;
    assigned_to_id?: number;
    assigned_to?: User;
    test_run_items?: TestRunItem[];
    project_users?: {
        user_id: number;
        user_first_name: string;
        user_last_name: string;
    }[];
}

export interface TestRunCreate {
    name: string;
    description?: string;
    project_id: number;
    environment: string;
}

export interface TestRunUpdate {
    name?: string;
    description?: string;
    environment?: string;
    status?: TestRunStatus;
    project_id?: number;
} 